import { render, staticRenderFns } from "./DonutChart09Dbm.vue?vue&type=template&id=4070cb88&scoped=true&"
import script from "./DonutChart09Dbm.vue?vue&type=script&lang=js&"
export * from "./DonutChart09Dbm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4070cb88",
  null
  
)

export default component.exports